import React, { useState, useEffect } from "react";
import CustomLoader from "../../common/Loader";
import { toaster } from '../../../config';
import { logActivity } from '../../../services/utilService';
import { Actions } from "../../../constants/ClickEventActions";
import { getButton, saveButton, getSPV, findParameters} from "../../../services/formService";
import { getProjectForms } from "../../../services/projectService";
import { getDataSources } from "../../../services/dataSourceService";
import { ResultSource } from "../../../constants/ResultSource";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { getRoles } from "../../../services/userService";

function WButton({Project_ID, Form_ID, Widget_ID, onRemove}) {
    const [loading, setLoading] = useState(true);
    const [buttonText, setButtonText] = useState('');
    const [withinRow, setWithinRow] = useState(false);
    const [rowActions, setRowActions] = useState([]);
    const [actionId, setActionId] = useState(0);
    const [forms, setForms] = useState([]);
    const [formRedirectTo, setFormRedirectTo] = useState(0);
    
    const [dataSources, setDataSources] = useState([]);
    const [dataSourceId, setDataSourceId] = useState(0);
    const [SPName, setSPName] = useState(null);
    const [SPParameters, setSPParameters] = useState(null);
    const [SPOptions, setSPOptions] = useState([]);

    const [saveResponse, setSaveResponse] = useState(false);
    const [reloadFormOnPopUpClose, setReloadFormOnPopUpClose] = useState(0);

    const [roles, setRoles] = useState()
    const [roleID, setRoleID] = useState(0)

    useEffect(() => {
        const getBtnData = async () => {
            let { data } = await getButton(Widget_ID);
            setRowActions(JSON.parse(data.rowActions));
            let btnData = JSON.parse(data.button);
            if(btnData.length > 0) {
                setButtonText(btnData[0].Button_Text || '');
                setWithinRow(btnData[0].WithinRow || false);
                setActionId(btnData[0].Action_ID || 0);
                setFormRedirectTo(btnData[0].Form_RedirectTo || 0);
                setDataSourceId(btnData[0].DataSource_ID || 0);
                setSPName(btnData[0].StoredProcedure_Name);
                setSPParameters(btnData[0].StoredProcedure_Parameters);
                setSaveResponse(btnData[0].Save_Response);
                setReloadFormOnPopUpClose(btnData[0].ReloadFormOnPopUpClose || 0);
                setRoleID(btnData[0].VisibleTo_Role_ID || 0)
            }
        };

        const getFormData = async() => {
            let { data: Forms } = await getProjectForms(Project_ID);
            setForms(Forms.filter((form) => form.Form_ID !== Form_ID));
        }
            
        const getDataSourcesData = async() => {
            let { data: DS } = await getDataSources();
            setDataSources(DS);
            if(dataSourceId && dataSourceId !== 0) {
                await updateSPOptions(dataSourceId);
            }
        };

        const getuserRoles = async () => {
            let { data: Roles } = await getRoles();
            Roles = Roles.filter(
                (role) => role.Role_Level !== 1 && role.Role_Level !== 999
            );
            setRoles(Roles)
        }

        getBtnData()
        .then(getFormData)
        .then(getDataSourcesData)
        .then(getuserRoles)
        .then(() => setLoading(false));
    }, []);

    const handleSave = async() => {
        //Clear unrelated fields depending on the action type
        if(actionId !== Actions.ExecuteSP) {
            setDataSourceId(null);
            setSPName(null);
            setSPParameters(null);
        }
        else {
            setFormRedirectTo(null);
        }

        const { data } = await saveButton(
            Widget_ID, buttonText, withinRow, actionId,formRedirectTo,
            dataSourceId, SPName, SPParameters, saveResponse, reloadFormOnPopUpClose, roleID
        );
        if (data.includes("Error")) {
            toaster('error', data);
            logActivity('/formBuilder', 'WIDGET_BUTTON_FAILED');
        } else {
            toaster('success', 'Widget saved.');
            logActivity('/formBuilder', 'WIDGET_BUTTON_SAVE_SUCCESS');
        }
    }

    const handleDataSourceChange = async(e) => {
        let value = parseInt(e.target.value);
        setDataSourceId(value);
        await updateSPOptions(value);
    }

    const updateSPOptions = async(DataSource_ID) => {
        let connString = dataSources.find((s) => s.DataSource_ID === DataSource_ID).Connection_String;
        const { data } = await getSPV(ResultSource.SP, connString);
        setSPOptions(data);
    }

    const handleSPNameChange = async(e, newValue) => {
        setSPName(newValue);
        let connString = dataSources.find((s) => s.DataSource_ID === dataSourceId).Connection_String;
        const { data } = await findParameters(newValue, connString);
        setSPParameters(JSON.stringify(data));
    }

    if (loading) {
        return <CustomLoader loading={loading} />;
    }
    return (
        <>
            <div className="form-group" key={Widget_ID}>
                <label htmlFor={"btnText" + Widget_ID}>Button Text</label>
                <input
                    className="form-control"
                    id={"btnText" + Widget_ID}
                    type="text"
                    name="btnText"
                    value={buttonText}
                    onChange={(e) => setButtonText(e.target.value)}
                />
            </div>
            <div className='row'>
                <div className="col-md-4 form-group">
                    <div className="custom-control custom-switch mt-n2">
                        <input
                            type="checkbox"
                            name='Include_RowWidget'
                            id={'rowSwitch' + Widget_ID}
                            className="custom-control-input"
                            checked={withinRow}
                            value={withinRow}
                            onChange={(e) => setWithinRow(!withinRow)}
                        />
                        <label htmlFor={'rowSwitch' + Widget_ID} className="custom-control-label">
                            Include in row widget
                        </label>
                    </div>
                </div>
                {/*TODO button color option}*/}
                <div className="col-md-4 form-group">
                    <div className="custom-control custom-switch mt-n2">
                        <input
                            type="checkbox"
                            id={'saveResponse' + Widget_ID}
                            className="custom-control-input"
                            checked={saveResponse}
                            value={saveResponse}
                            onChange={(e) => setSaveResponse(!saveResponse)}
                        />
                        <label htmlFor={'saveResponse' + Widget_ID} className="custom-control-label">
                            Save Response on Click
                        </label>
                    </div>
                </div>
            </div>
            <div className="form-row" key={Widget_ID + "clickEvent"}>
                <div className="form-group col-md-4">
                    <label htmlFor={"row_action" + Widget_ID}>Click Event Action</label>
                    <select
                        id={"row_action" + Widget_ID}
                        name={Widget_ID + ":Action_ID"}
                        value={actionId}
                        className="form-control"
                        onChange={(e) => setActionId(parseInt(e.target.value))}
                    >
                        <option value="0">Select</option>
                        {rowActions.map((action) => {
                            return (
                                <option key={action.Action_ID} value={action.Action_ID}>
                                    {action.Action_Name}
                                </option>
                            );
                        })}
                    </select>
                </div>
                {(actionId === Actions.PopUp || actionId === Actions.RedirectTo) &&
                     (
                    <div className="form-group col-md-8">
                        <label htmlFor={"action_form" + Widget_ID}>Form</label>
                        <select
                            id={"action_form" + Widget_ID}
                            className="form-control"
                            name={Widget_ID + ":Action_Form_ID"}
                            value={formRedirectTo}
                            onChange={(e) => setFormRedirectTo(parseInt(e.target.value))}
                        >
                            <option value="0">Select</option>
                            {forms.map((form) => {
                                return (
                                    <option key={form.Form_ID} value={form.Form_ID}>
                                        {form.Form_Name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                )}
                {actionId === Actions.ExecuteSP && (
                    <div className="form-group col-md-2">
                        <label htmlFor={"DataSource" + Widget_ID}>Data Source</label>
                        <select
                            id={"DataSource" + Widget_ID}
                            className="form-control"
                            value={dataSourceId}
                            name="DataSource_ID"
                            onChange={handleDataSourceChange}
                        >
                            <option value="0" key={Widget_ID + "DSDefault"}>
                                Select
                            </option>
                            {dataSources.map((source) => (
                                <option
                                    key={Widget_ID + "DataSource" + source.DataSource_ID}
                                    value={source.DataSource_ID}
                                >
                                    {source.Description}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
            </div>
            {actionId === Actions.ExecuteSP && dataSourceId !== 0 && (
                <div className="form-row">
                    <div className="form-group col-md-6">
                        <Autocomplete
                            id={Widget_ID + "resultSourceContent"}
                            options={SPOptions}
                            value={SPName}
                            name="ResultSource_Content"
                            onChange={handleSPNameChange}
                            renderInput={(params) => <TextField {...params} label="Stored Procedure Name"/>}
                        />
                    </div>
                </div>
            )}
            {actionId === Actions.PopUp && (
                <div className="form-row">
                    <div className="custom-control custom-switch mt-n2">
                        <input
                            type="checkbox"
                            id={'reloadForm' + Widget_ID}
                            className="custom-control-input"
                            checked={reloadFormOnPopUpClose}
                            value={reloadFormOnPopUpClose}
                            onChange={(e) => setReloadFormOnPopUpClose(!reloadFormOnPopUpClose)}
                        />
                        <label htmlFor={'reloadForm' + Widget_ID} className="custom-control-label">
                            Reload form containing this button upon closing pop up
                        </label>
                    </div>
                </div>
            )}
            <div className="form-row" key={Widget_ID + "visibleTo"}>
                    <label htmlFor={"row_role" + Widget_ID} className="form-group col-md-0 p-2">Visible To: </label>
                    <select
                        id={"row_role" + Widget_ID}
                        name={Widget_ID + ":Role_ID"}
                        value={roleID}
                        // className="form-control"
                        className="form-group col-md-2 form-control"
                        onChange={(e) => setRoleID(parseInt(e.target.value))}
                    >
                        <option value="0">Select</option>
                        {roles.map((role) => {
                            return (
                                <option key={role.Role_ID} value={role.Role_ID}>
                                    {role.Role_Name}
                                </option>
                            );
                        })}
                    </select>
            </div>
            <div className="d-flex justify-content-end mt-2">
                <button
                    className="btn btn-outline-primary mr-2"
                    onClick={handleSave}
                >
                    Save
                </button>
                <button
                    className="btn btn-outline-danger"
                    onClick={() => onRemove(Widget_ID)}
                >
                    Delete
                </button>
            </div>
        </>
    )
}

export default WButton;
